
import { useState } from "react"
import { Col, Row, Card } from "react-bootstrap"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import Swal from "sweetalert2"
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const DoctorAvailability = () => {
  const [calendarEvents, setCalendarEvents] = useState([
    {
      title: "6:00 AM- 11:00 AM",
      start: "2025-04-07T18:00:00",
      end: "2025-04-07T19:00:00",
      id: "available-1",
      classNames: ["bg-success"],
    },
    {
      title: "11:00 AM - 8:00 PM",
      start: "2025-04-07T18:00:00",
      end: "2025-04-07T19:00:00",
      id: "not-available-1",
      classNames: ["bg-danger", "text-white"],
    },
    {
      title: "8:00 PM - 10:00 PM",
      start: "2025-04-07T18:00:00",
      end: "2025-04-07T19:00:00",
      id: "available-1",
      classNames: ["bg-success"],
    },
    {
      title: "7:00 AM - 1:00 PM",
      start: "2025-04-08T19:00:00",
      end: "2025-04-08T20:00:00",
      id: "not-available-1",
      classNames: ["bg-danger", "text-white"],
    },
    {
      title: "1:00 PM - 8:00 PM",
      start: "2025-04-08T18:00:00",
      end: "2025-04-08T19:00:00",
      id: "available-1",
      classNames: ["bg-success"],
    },
    {
      title: "8:00 PM - 10:00 PM",
      start: "2025-04-08T18:00:00",
      end: "2025-04-08T19:00:00",
      id: "not-available-1",
      classNames: ["bg-danger", "text-white"],
    },
    {
      title: "Holiday",
      start: "2025-04-09T19:00:00",
      end: "2025-04-09T20:00:00",
      id: "holiday-1",
      classNames: ["bg-warning"],
    },
  ])

  const handleDateClick = (arg) => {
    Swal.fire({
      title: "Select Availability",
      html: `
        <div style="display: flex; flex-direction: column; gap: 15px;">
          <div style="display: flex; justify-content: space-around;">
            <label><input type="radio" name="availability" value="available" id="availableRadio" style="margin-right: 5px;" /> Available</label>
            <label><input type="radio" name="availability" value="not-available" id="notAvailableRadio" style="margin-right: 5px;" /> Not Available</label>
            <label><input type="radio" name="availability" value="holiday" id="holidayRadio" style="margin-right: 5px;" /> Holiday</label>
          </div>
          <div id="timeSlots" style="display: none;">
            <div id="timeSlotInputs"></div>
            <div style="display: flex; justify-content: center; margin-top: 10px;">
              <button id="addTimeSlotBtn" class="btn btn-primary" type="button"
                style="width: 80px; height: 28px; font-size: 0.75rem; padding: 2px 6px;">
                Add Slot
              </button>
            </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
      didOpen: () => {
        const timeSlotsDiv = document.getElementById("timeSlots")
        const availableRadio = document.getElementById("availableRadio")
        const notAvailableRadio = document.getElementById("notAvailableRadio")
        const holidayRadio = document.getElementById("holidayRadio")

        availableRadio.addEventListener("change", () => (timeSlotsDiv.style.display = "block"))
        notAvailableRadio.addEventListener("change", () => (timeSlotsDiv.style.display = "block"))
        holidayRadio.addEventListener("change", () => (timeSlotsDiv.style.display = "none"))

        document.getElementById("addTimeSlotBtn").addEventListener("click", () => {
          const timeSlotInputs = document.getElementById("timeSlotInputs")
          const newRow = document.createElement("div")
          newRow.style.cssText =
            "display: flex; align-items: flex-end; gap: 10px; margin-bottom: 10px; padding: 10px; background: #f8f9fa; border-radius: 6px; border: 1px solid #ccc;"
          newRow.innerHTML = `
            <div style="flex: 1; position: relative;">
              <label style="font-weight: 500;">From</label>
              <input type="time" class="fromTime form-control" required style="padding-right: 30px;" />
              <i class="far fa-clock" style="position: absolute; right: 10px; top: 45px; font-size: 18px; color: #aaa;"></i>
            </div>
            <div style="flex: 1; position: relative;">
              <label style="font-weight: 500;">To</label>
              <input type="time" class="toTime form-control" required style="padding-right: 30px;" />
              <i class="far fa-clock" style="position: absolute; right: 10px; top: 45px; font-size: 18px; color: #aaa;"></i>
            </div>
            <button type="button" class="remove-slot btn btn-outline-danger">✕</button>
          `
          timeSlotInputs.appendChild(newRow)
          newRow.querySelector(".remove-slot").addEventListener("click", () => newRow.remove())
        })

        document.getElementById("addTimeSlotBtn").click()
      },
      preConfirm: () => {
        const availability = document.querySelector('input[name="availability"]:checked')
        if (!availability) {
          Swal.showValidationMessage("Please select availability.")
          return false
        }

        const newEvents = []
        if (availability.value === "holiday") {
          newEvents.push({
            title: "Holiday",
            start: arg.dateStr,
            end: arg.dateStr,
            classNames: ["bg-warning"],
            allDay: true,
            id: `holiday-${Date.now()}`,
          })
        } else {
          const slotRows = document.querySelectorAll("#timeSlotInputs > div")
          let isValid = true

          slotRows.forEach((row, index) => {
            const fromInput = row.querySelector(".fromTime")
            const toInput = row.querySelector(".toTime")

            const fromTime = fromInput?.value
            const toTime = toInput?.value

            if (!fromTime || !toTime) {
              isValid = false
              return
            }

            const startDateTime = new Date(`${arg.dateStr}T${fromTime}`)
            const endDateTime = new Date(`${arg.dateStr}T${toTime}`)

            const formatTime = (time) => {
              const [hours, minutes] = time.split(":")
              const hour = Number.parseInt(hours, 10)
              const meridian = hour >= 12 ? "PM" : "AM"
              const formattedHour = hour % 12 || 12
              return `${formattedHour}:${minutes} ${meridian}`
            }

            newEvents.push({
              title: `${formatTime(fromTime)} - ${formatTime(toTime)}`,
              start: startDateTime,
              end: endDateTime,
              classNames: [availability.value === "available" ? "bg-success" : "bg-danger text-white"],
              id: `${availability.value}-${Date.now()}-${index}`,
            })
          })

          if (!isValid) {
            Swal.showValidationMessage("Please fill in all time slots.")
            return false
          }
        }

        return newEvents
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        setCalendarEvents((prev) => [...prev, ...result.value])
      }
    })
  }

  // const eventClick = ({ event }) => {
  //   Swal.fire({
  //     title: event.title.split("\n")[0],
  //     text: "Do you want to delete this event?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Delete",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       setCalendarEvents((prev) => prev.filter((e) => e.id !== event.id))
  //       Swal.fire("Deleted!", "Your event has been deleted.", "success")
  //     }
  //   })
  // }

  // Add custom styles to ensure consistent event styling
  const customStyles = `
  .fc-event {
    border-radius: 4px !important;
    border: none !important;
    overflow: hidden !important;
  }
  .fc-daygrid-event {
    border-radius: 4px !important;
    overflow: hidden !important;
  }
  .fc-event-title {
    text-align: center !important;
    width: 100% !important;
  }
  .fc-daygrid-event-dot {
    display: none !important;
  }
`

  return (
    <div style={{ padding: "20px" }}>
      <Row>
        <Col lg={12}>
          <Card>
       
            <Card.Body>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
      <h5 style={{ fontWeight: "bold", margin: 0 }}>Doctor Availability Calendar</h5>
      <Link to="/doctors" className="btn btn-link" aria-label="Back to Doctors">
        <Button variant="primary">Back</Button>
      </Link>
    </div>
              <style>{customStyles}</style>
              <FullCalendar
                headerToolbar={{
                  left: "prev,next today",
                  center: "title",
                  right: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                events={calendarEvents}
                editable
                droppable
                dateClick={handleDateClick}
                // eventClick={eventClick}
                initialView="dayGridMonth"
                eventContent={(arg) => {
                  // Get the event's classNames to determine if it's a "not available" event
                  const isNotAvailable = arg.event.classNames.includes("bg-danger")

                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        textAlign: "center",
                        whiteSpace: "pre-line",
                        fontWeight: "bold",
                        fontSize: "0.85rem",
                        padding: "5px",
                        borderRadius: "4px",
                        overflow: "hidden",
                        boxSizing: "border-box",
                        color: isNotAvailable ? "white" : "inherit",
                      }}
                    >
                      {arg.event.title}
                    </div>
                  )
                }}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default DoctorAvailability;
